export default function Developer (props) {

    return (
        <svg stroke={props.stroke || 'transparent'} fill={props.fill || '#000'} className={props.className} style={props.style} xmlns="http://www.w3.org/2000/svg" viewBox="2 0 44 24">
            <path d="M 14 0 L 2 12 L 14 24 L 17 21 L 8 12 L 17 3 M 30 0 L 22 24 L 18 24 L 26 0 M 31 3 L 34 0 L 46 12 L 34 24 L 31 21 L 40 12"/>
        </svg>
    )

}